import { Box, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { BsFillPlayFill } from "react-icons/bs";
import ImageMagnifier from "../../../Products/ImageMagnifier";
import ReactPlayer from "react-player";

export const ProductImages = ({ sliderItems }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imgIndex, setImgIndex] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeIcon, setActiveIcon] = useState("image");

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => {
      return prevIndex > 0 ? prevIndex - 1 : prevIndex;
    });
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => {
      return prevIndex < slideImage.length - 1 ? prevIndex + 1 : prevIndex;
    });
  };

  const handleImageSelect = (image, index) => {
    setSelectedImage(image);
    setImgIndex(index);
  };

  const slideImage =
    sliderItems.length > 3
      ? [
          sliderItems[
            (currentIndex - 1 + sliderItems.length) % sliderItems.length
          ],
          sliderItems[currentIndex],
          sliderItems[(currentIndex + 1) % sliderItems.length],
        ]
      : sliderItems;

  // console.log(slideImage);
  // console.log(sliderItems);

  useEffect(() => {
    setSelectedImage(sliderItems[0])
  }, [sliderItems])

  const goToFirstIndex = () => {
    if (imgIndex !== 0) {
      setCurrentIndex(0);
      setImgIndex(0);
      setSelectedImage(sliderItems[0]);
    }
    setActiveIcon("image");
  };

  const goToLastIndex = () => {
    if (imgIndex !== sliderItems.length - 1) {
      setCurrentIndex(sliderItems.length - 1);
      setImgIndex(sliderItems.length - 1);
      setSelectedImage(sliderItems[sliderItems.length - 1]);
    }
    setActiveIcon("lab360");
  };
  const goToVideoIndex = () => {
    const videoIndex = sliderItems.findIndex((item) => item.type === "VIDEO");
    if (videoIndex !== -1) {
      setCurrentIndex(videoIndex);
      setSelectedImage(sliderItems[videoIndex]);
      setImgIndex(videoIndex);
    }
    setActiveIcon("video")
  };

  return (
    <Box sx={{ display: { xs: "none", sm: "flex" }, flexDirection: "column" }}>
      <Box
        sx={{
          border: "1px solid  #E0E0E0",
          maxWidth: { sm: "360px", md: "487px", lg: "596px" },
          height: { sm: "323px", md: "421px" },
          position: "relative",
        }}
      >
        <Box
          sx={{
            height: "100%",
            minWidth: "100%",
          }}
        >
          <Box
            sx={{
              // display: "flex",
              // justifyContent: "center",
              height: "100%",
              // minWidth: "100%",
              // width:"100%"
              // alignItems: "center",
            }}
          >
            {selectedImage && (
              <>
                {selectedImage.type === "IMAGE" && (
                  <ImageMagnifier src={selectedImage.url} />
                )}
                {selectedImage.type === "lab360" && (
                  <iframe
                    title="360"
                    src={selectedImage.url}
                    width="100%"
                    height="100%"
                    scrolling="no"
                  ></iframe>
                )}
                {selectedImage.type === "vendor360" && (
                  <iframe
                    title="360"
                    src={selectedImage.url}
                    width="100%"
                    height="100%"
                    scrolling="no"
                  ></iframe>
                )}
                {selectedImage.type === "VIDEO" && (
                  <Box sx={{ width: "100%", height: "100%" }}>
                    <ReactPlayer
                      url={selectedImage.url}
                      width="100%"
                      height="100%"
                      controls={true}
                    />
                  </Box>
                )}
              </>
            )}
          </Box>
        </Box>
        <Box
          sx={{
            position: "absolute",
            top: "1.25rem",
            zIndex: "1",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", pl: "16px" }}>
            <Box
              sx={{
                border: "0.5px solid #E0E0E0",
                cursor: "pointer",
                display: sliderItems.some((item) => item.type === "IMAGE")
                  ? "block"
                  : "none",
              }}
              onClick={goToFirstIndex}
            >
              <Box>
                <svg
                  width="64"
                  height="64"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.25"
                    y="0.25"
                    width="63.5"
                    height="63.5"
                    rx="3.75"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M26.937 15.8454C27.0079 15.7469 27.0866 15.6263 27.1869 15.4637C27.2235 15.4043 27.3235 15.2394 27.3979 15.1166L27.398 15.1165L27.4818 14.9784C28.3108 13.6224 28.9134 13 30 13H34C35.0866 13 35.6892 13.6224 36.5182 14.9784L36.6021 15.1166C36.6765 15.2394 36.7765 15.4043 36.8131 15.4637C36.9134 15.6263 36.9921 15.7469 37.063 15.8454C37.1097 15.9103 37.1505 15.9619 37.1838 16H40C41.6569 16 43 17.3431 43 19V28C43 29.6569 41.6569 31 40 31H24C22.3431 31 21 29.6569 21 28V19C21 17.3431 22.3431 16 24 16H26.8162C26.8495 15.9619 26.8903 15.9103 26.937 15.8454ZM24 18C23.4477 18 23 18.4477 23 19V28C23 28.5523 23.4477 29 24 29H40C40.5523 29 41 28.5523 41 28V19C41 18.4477 40.5523 18 40 18H37C36.3357 18 35.8876 17.6364 35.4394 17.0133C35.3363 16.8699 35.2341 16.7133 35.1111 16.5141C35.069 16.4458 34.9596 16.2654 34.8846 16.1415L34.8118 16.0216C34.3595 15.2817 34.0867 15 34 15H30C29.9133 15 29.6405 15.2817 29.1882 16.0216L29.1154 16.1415L29.115 16.1422C29.04 16.266 28.9309 16.446 28.8889 16.5141C28.7659 16.7133 28.6637 16.8699 28.5606 17.0133C28.1124 17.6364 27.6643 18 27 18H24ZM40 20C40 20.5523 39.5523 21 39 21C38.4477 21 38 20.5523 38 20C38 19.4477 38.4477 19 39 19C39.5523 19 40 19.4477 40 20ZM27 23C27 25.7614 29.2386 28 32 28C34.7614 28 37 25.7614 37 23C37 20.2386 34.7614 18 32 18C29.2386 18 27 20.2386 27 23ZM35 23C35 24.6569 33.6569 26 32 26C30.3431 26 29 24.6569 29 23C29 21.3431 30.3431 20 32 20C33.6569 20 35 21.3431 35 23Z"
                    fill={`${activeIcon === "image" ? " #333333" : "#858585"}`}
                  />
                  <path
                    d="M13.662 49V39.13H17.848C18.9027 39.13 19.71 39.3867 20.27 39.9C20.8393 40.404 21.124 41.104 21.124 42C21.124 42.896 20.8393 43.6007 20.27 44.114C19.71 44.6273 18.9027 44.884 17.848 44.884H15.118V49H13.662ZM15.118 43.722H17.694C18.3567 43.722 18.856 43.5727 19.192 43.274C19.528 42.9753 19.696 42.5507 19.696 42C19.696 41.4587 19.528 41.0387 19.192 40.74C18.856 40.4413 18.3567 40.292 17.694 40.292H15.118V43.722ZM22.7508 49V38.696H24.1648V43.442H23.9688C24.1742 42.91 24.5055 42.5087 24.9628 42.238C25.4202 41.958 25.9475 41.818 26.5448 41.818C27.3848 41.818 28.0102 42.0513 28.4208 42.518C28.8315 42.9753 29.0368 43.6707 29.0368 44.604V49H27.6228V44.688C27.6228 44.0813 27.5015 43.6427 27.2588 43.372C27.0255 43.092 26.6522 42.952 26.1388 42.952C25.5415 42.952 25.0608 43.1387 24.6968 43.512C24.3422 43.876 24.1648 44.3613 24.1648 44.968V49H22.7508ZM34.0737 49.126C33.3737 49.126 32.767 48.9813 32.2537 48.692C31.7403 48.3933 31.3437 47.9733 31.0637 47.432C30.7837 46.8813 30.6437 46.228 30.6437 45.472C30.6437 44.716 30.7837 44.0673 31.0637 43.526C31.3437 42.9753 31.7403 42.5553 32.2537 42.266C32.767 41.9673 33.3737 41.818 34.0737 41.818C34.7737 41.818 35.3803 41.9673 35.8937 42.266C36.4163 42.5553 36.8177 42.9753 37.0977 43.526C37.387 44.0673 37.5317 44.716 37.5317 45.472C37.5317 46.228 37.387 46.8813 37.0977 47.432C36.8177 47.9733 36.4163 48.3933 35.8937 48.692C35.3803 48.9813 34.7737 49.126 34.0737 49.126ZM34.0737 48.02C34.6897 48.02 35.1797 47.8053 35.5437 47.376C35.9077 46.9467 36.0897 46.312 36.0897 45.472C36.0897 44.632 35.9077 44.002 35.5437 43.582C35.1797 43.1527 34.6897 42.938 34.0737 42.938C33.467 42.938 32.9817 43.1527 32.6177 43.582C32.2537 44.002 32.0717 44.632 32.0717 45.472C32.0717 46.312 32.249 46.9467 32.6037 47.376C32.9677 47.8053 33.4577 48.02 34.0737 48.02ZM41.8601 49.126C41.0947 49.126 40.5161 48.9207 40.1241 48.51C39.7321 48.09 39.5361 47.4647 39.5361 46.634V43.036H38.1641V41.944H39.5361V40.082L40.9501 39.704V41.944H42.9101V43.036H40.9501V46.508C40.9501 47.0307 41.0434 47.404 41.2301 47.628C41.4167 47.852 41.6874 47.964 42.0421 47.964C42.2194 47.964 42.3734 47.95 42.5041 47.922C42.6441 47.8847 42.7701 47.8427 42.8821 47.796V48.944C42.7421 49 42.5787 49.042 42.3921 49.07C42.2054 49.1073 42.0281 49.126 41.8601 49.126ZM47.1577 49.126C46.4577 49.126 45.851 48.9813 45.3377 48.692C44.8243 48.3933 44.4277 47.9733 44.1477 47.432C43.8677 46.8813 43.7277 46.228 43.7277 45.472C43.7277 44.716 43.8677 44.0673 44.1477 43.526C44.4277 42.9753 44.8243 42.5553 45.3377 42.266C45.851 41.9673 46.4577 41.818 47.1577 41.818C47.8577 41.818 48.4643 41.9673 48.9777 42.266C49.5003 42.5553 49.9017 42.9753 50.1817 43.526C50.471 44.0673 50.6157 44.716 50.6157 45.472C50.6157 46.228 50.471 46.8813 50.1817 47.432C49.9017 47.9733 49.5003 48.3933 48.9777 48.692C48.4643 48.9813 47.8577 49.126 47.1577 49.126ZM47.1577 48.02C47.7737 48.02 48.2637 47.8053 48.6277 47.376C48.9917 46.9467 49.1737 46.312 49.1737 45.472C49.1737 44.632 48.9917 44.002 48.6277 43.582C48.2637 43.1527 47.7737 42.938 47.1577 42.938C46.551 42.938 46.0657 43.1527 45.7017 43.582C45.3377 44.002 45.1557 44.632 45.1557 45.472C45.1557 46.312 45.333 46.9467 45.6877 47.376C46.0517 47.8053 46.5417 48.02 47.1577 48.02Z"
                    fill={`${activeIcon === "image" ? " #333333" : "#858585"}`}
                  />
                  <rect
                    x="0.25"
                    y="0.25"
                    width="63.5"
                    height="63.5"
                    rx="3.75"
                    stroke="#E0E0E0"
                    stroke-width="0.5"
                  />
                </svg>
              </Box>
            </Box>
            <Box
              sx={{
                border: "0.5px solid #E0E0E0",
                mt: "16px",

                cursor: "pointer",
                display: sliderItems.some(
                  (item) => item.type === "vendor360" || item.type === "lab360"
                )
                  ? "block"
                  : "none",
              }}
              onClick={goToLastIndex}
            >
              <Box>
                <svg
                  width="64"
                  height="64"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.25"
                    y="0.25"
                    width="63.5"
                    height="63.5"
                    rx="3.75"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M30 17H26.1931C27.5535 15.0787 29.6064 14 32 14C36.4183 14 40 17.5817 40 22H42C42 16.4772 37.5228 12 32 12C29.1958 12 26.7251 13.1825 25 15.2703V12H23V19H30V17ZM34 27H37.8069C36.4465 28.9213 34.3936 30 32 30C27.5817 30 24 26.4183 24 22H22C22 27.5228 26.4772 32 32 32C34.8042 32 37.2749 30.8175 39 28.7297V32H41V25H34V27Z"
                    fill={`${activeIcon === "lab360" ? " #333333" : "#858585"}`}
                  />
                  <path
                    d="M20.644 49.126C19.9813 49.126 19.3467 49.0233 18.74 48.818C18.1333 48.6127 17.6247 48.3187 17.214 47.936L17.648 47.04C18.1053 47.4133 18.5767 47.684 19.062 47.852C19.5473 48.02 20.07 48.104 20.63 48.104C21.3673 48.104 21.9273 47.95 22.31 47.642C22.6927 47.3247 22.884 46.8627 22.884 46.256C22.884 45.6773 22.688 45.2387 22.296 44.94C21.904 44.632 21.33 44.478 20.574 44.478H19.09V43.512H20.476C21.1293 43.512 21.6473 43.344 22.03 43.008C22.4127 42.672 22.604 42.2147 22.604 41.636C22.604 41.1133 22.4267 40.7167 22.072 40.446C21.7267 40.166 21.2273 40.026 20.574 40.026C19.51 40.026 18.5907 40.404 17.816 41.16L17.382 40.25C17.7647 39.858 18.2453 39.5547 18.824 39.34C19.4027 39.116 20.0093 39.004 20.644 39.004C21.6147 39.004 22.3753 39.228 22.926 39.676C23.4767 40.124 23.752 40.7447 23.752 41.538C23.752 42.1447 23.5793 42.6673 23.234 43.106C22.8887 43.5353 22.422 43.8293 21.834 43.988V43.834C22.534 43.946 23.0753 44.226 23.458 44.674C23.8407 45.1127 24.032 45.668 24.032 46.34C24.032 47.1987 23.7287 47.88 23.122 48.384C22.5247 48.8787 21.6987 49.126 20.644 49.126ZM29.4165 49.126C28.2219 49.126 27.2979 48.706 26.6445 47.866C26.0005 47.0167 25.6785 45.8313 25.6785 44.31C25.6785 43.1713 25.8419 42.21 26.1685 41.426C26.4952 40.6327 26.9619 40.0307 27.5685 39.62C28.1752 39.2093 28.9079 39.004 29.7665 39.004C30.2799 39.004 30.7979 39.1113 31.3205 39.326C31.8432 39.5313 32.2725 39.8207 32.6085 40.194L32.1885 41.09C31.8339 40.726 31.4465 40.46 31.0265 40.292C30.6065 40.1147 30.1819 40.026 29.7525 40.026C28.8005 40.026 28.0679 40.3667 27.5545 41.048C27.0505 41.72 26.7985 42.7327 26.7985 44.086V45.388H26.6725C26.7379 44.856 26.8965 44.3987 27.1485 44.016C27.4099 43.624 27.7505 43.3253 28.1705 43.12C28.5905 42.9147 29.0572 42.812 29.5705 42.812C30.1679 42.812 30.6952 42.9427 31.1525 43.204C31.6099 43.4653 31.9692 43.834 32.2305 44.31C32.4919 44.7767 32.6225 45.3133 32.6225 45.92C32.6225 46.536 32.4872 47.0867 32.2165 47.572C31.9459 48.0573 31.5679 48.44 31.0825 48.72C30.5972 48.9907 30.0419 49.126 29.4165 49.126ZM29.3325 48.146C29.7619 48.146 30.1399 48.0573 30.4665 47.88C30.8025 47.6933 31.0592 47.4367 31.2365 47.11C31.4232 46.774 31.5165 46.3913 31.5165 45.962C31.5165 45.5327 31.4232 45.1547 31.2365 44.828C31.0592 44.5013 30.8025 44.2447 30.4665 44.058C30.1399 43.8713 29.7619 43.778 29.3325 43.778C28.9032 43.778 28.5252 43.8713 28.1985 44.058C27.8719 44.2447 27.6152 44.5013 27.4285 44.828C27.2512 45.1547 27.1625 45.5327 27.1625 45.962C27.1625 46.3913 27.2512 46.774 27.4285 47.11C27.6152 47.4367 27.8719 47.6933 28.1985 47.88C28.5252 48.0573 28.9032 48.146 29.3325 48.146ZM37.4891 49.126C36.3691 49.126 35.5104 48.692 34.9131 47.824C34.3157 46.956 34.0171 45.7007 34.0171 44.058C34.0171 42.406 34.3157 41.1507 34.9131 40.292C35.5104 39.4333 36.3691 39.004 37.4891 39.004C38.6184 39.004 39.4771 39.4333 40.0651 40.292C40.6624 41.1507 40.9611 42.4013 40.9611 44.044C40.9611 45.696 40.6624 46.956 40.0651 47.824C39.4677 48.692 38.6091 49.126 37.4891 49.126ZM37.4891 48.118C38.2731 48.118 38.8564 47.7867 39.2391 47.124C39.6217 46.4613 39.8131 45.4347 39.8131 44.044C39.8131 42.644 39.6217 41.622 39.2391 40.978C38.8564 40.3247 38.2731 39.998 37.4891 39.998C36.7144 39.998 36.1311 40.3247 35.7391 40.978C35.3564 41.6313 35.1651 42.6533 35.1651 44.044C35.1651 45.4347 35.3564 46.4613 35.7391 47.124C36.1311 47.7867 36.7144 48.118 37.4891 48.118ZM44.2876 43.148C43.8956 43.148 43.5409 43.0547 43.2236 42.868C42.9063 42.6813 42.6543 42.434 42.4676 42.126C42.2903 41.818 42.2016 41.468 42.2016 41.076C42.2016 40.684 42.2903 40.334 42.4676 40.026C42.6543 39.7087 42.9063 39.4613 43.2236 39.284C43.5409 39.0973 43.8956 39.004 44.2876 39.004C44.6796 39.004 45.0296 39.0973 45.3376 39.284C45.6456 39.4613 45.8883 39.704 46.0656 40.012C46.2523 40.32 46.3456 40.6747 46.3456 41.076C46.3456 41.468 46.2523 41.8227 46.0656 42.14C45.8883 42.448 45.6456 42.6953 45.3376 42.882C45.0296 43.0593 44.6796 43.148 44.2876 43.148ZM44.2876 42.378C44.6609 42.378 44.9596 42.2567 45.1836 42.014C45.4169 41.762 45.5336 41.4493 45.5336 41.076C45.5336 40.6933 45.4169 40.3807 45.1836 40.138C44.9596 39.8953 44.6609 39.774 44.2876 39.774C43.9236 39.774 43.6203 39.8953 43.3776 40.138C43.1443 40.3807 43.0276 40.6933 43.0276 41.076C43.0276 41.4493 43.1443 41.762 43.3776 42.014C43.6109 42.2567 43.9143 42.378 44.2876 42.378Z"
                    fill={`${activeIcon === "lab360" ? " #333333" : "#858585"}`}
                  />
                  <rect
                    x="0.25"
                    y="0.25"
                    width="63.5"
                    height="63.5"
                    rx="3.75"
                    stroke="#E0E0E0"
                    stroke-width="0.5"
                  />
                </svg>
              </Box>
            </Box>
            <Box
              sx={{
                border: "0.5px solid #E0E0E0",
                mt: "16px",
                cursor: "pointer",
                display: sliderItems.some((item) => item.type === "VIDEO")
                  ? "block"
                  : "none",
              }}
              onClick={goToVideoIndex}
            >
              {/* <Box component="img" src="/images/viewVideo.png" /> */}
              <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.25" y="0.25" width="63.5" height="63.5" rx="3.75" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M23 15H35C36.1046 15 37 15.8954 37 17V18.382L43 15.382V28.618L37 25.618V27C37 28.1046 36.1046 29 35 29H23C21.8954 29 21 28.1046 21 27V17C21 15.8954 21.8954 15 23 15ZM37 23.382L41 25.382V18.618L37 20.618V23.382ZM23 17V27H35V17H23Z" fill={`${activeIcon === "video" ? " #333333" : "#858585"}`}/>
<path d="M17.34 49L13.042 39.13H14.288L18.11 48.076H17.676L21.526 39.13H22.73L18.404 49H17.34ZM23.8814 49V41.972H25.0154V49H23.8814ZM23.7414 40.376V39.102H25.1414V40.376H23.7414ZM29.8773 49.126C29.2613 49.126 28.72 48.9813 28.2533 48.692C27.7867 48.3933 27.4227 47.9733 27.1613 47.432C26.9093 46.8907 26.7833 46.242 26.7833 45.486C26.7833 44.7207 26.9093 44.0673 27.1613 43.526C27.4227 42.9847 27.7867 42.5693 28.2533 42.28C28.72 41.9907 29.2613 41.846 29.8773 41.846C30.512 41.846 31.058 42.0047 31.5153 42.322C31.982 42.6393 32.2947 43.0687 32.4533 43.61H32.2853V38.696H33.4193V49H32.2993V47.32H32.4533C32.304 47.88 31.996 48.3233 31.5293 48.65C31.0627 48.9673 30.512 49.126 29.8773 49.126ZM30.1153 48.202C30.778 48.202 31.31 47.9733 31.7113 47.516C32.1127 47.0493 32.3133 46.3727 32.3133 45.486C32.3133 44.59 32.1127 43.9133 31.7113 43.456C31.31 42.9893 30.778 42.756 30.1153 42.756C29.4527 42.756 28.9207 42.9893 28.5193 43.456C28.1273 43.9133 27.9313 44.59 27.9313 45.486C27.9313 46.3727 28.1273 47.0493 28.5193 47.516C28.9207 47.9733 29.4527 48.202 30.1153 48.202ZM38.7339 49.126C37.6325 49.126 36.7645 48.8087 36.1299 48.174C35.4952 47.53 35.1779 46.6387 35.1779 45.5C35.1779 44.7627 35.3179 44.1233 35.5979 43.582C35.8779 43.0313 36.2699 42.6067 36.7739 42.308C37.2779 42 37.8565 41.846 38.5099 41.846C39.1539 41.846 39.6952 41.9813 40.1339 42.252C40.5725 42.5227 40.9085 42.91 41.1419 43.414C41.3752 43.9087 41.4919 44.4967 41.4919 45.178V45.598H36.0459V44.884H40.7499L40.5119 45.066C40.5119 44.3193 40.3439 43.736 40.0079 43.316C39.6719 42.896 39.1725 42.686 38.5099 42.686C37.8099 42.686 37.2639 42.9333 36.8719 43.428C36.4799 43.9133 36.2839 44.5713 36.2839 45.402V45.528C36.2839 46.4053 36.4985 47.0727 36.9279 47.53C37.3665 47.978 37.9779 48.202 38.7619 48.202C39.1819 48.202 39.5739 48.1413 39.9379 48.02C40.3112 47.8893 40.6659 47.6793 41.0019 47.39L41.3939 48.188C41.0859 48.4867 40.6939 48.72 40.2179 48.888C39.7512 49.0467 39.2565 49.126 38.7339 49.126ZM46.1111 49.126C45.4391 49.126 44.8511 48.9813 44.3471 48.692C43.8524 48.3933 43.4698 47.9733 43.1991 47.432C42.9284 46.8813 42.7931 46.2327 42.7931 45.486C42.7931 44.73 42.9284 44.0813 43.1991 43.54C43.4698 42.9987 43.8524 42.5833 44.3471 42.294C44.8511 41.9953 45.4391 41.846 46.1111 41.846C46.7924 41.846 47.3804 41.9953 47.8751 42.294C48.3791 42.5833 48.7664 42.9987 49.0371 43.54C49.3171 44.0813 49.4571 44.73 49.4571 45.486C49.4571 46.2327 49.3171 46.8813 49.0371 47.432C48.7664 47.9733 48.3791 48.3933 47.8751 48.692C47.3804 48.9813 46.7924 49.126 46.1111 49.126ZM46.1111 48.202C46.7831 48.202 47.3151 47.9733 47.7071 47.516C48.0991 47.0493 48.2951 46.3727 48.2951 45.486C48.2951 44.59 48.0944 43.9133 47.6931 43.456C47.3011 42.9893 46.7738 42.756 46.1111 42.756C45.4484 42.756 44.9211 42.9893 44.5291 43.456C44.1371 43.9133 43.9411 44.59 43.9411 45.486C43.9411 46.3727 44.1371 47.0493 44.5291 47.516C44.9211 47.9733 45.4484 48.202 46.1111 48.202Z" fill={`${activeIcon === "video" ? " #333333" : "#858585"}`}/>
<rect x="0.25" y="0.25" width="63.5" height="63.5" rx="3.75" stroke="#E0E0E0" stroke-width="0.5"/>
</svg>

            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mt: "24px",
          width: { sm: "360px", md: "487px", lg: "596px" },
          justifyContent: "space-between",
        }}
      >
        <IconButton
          sx={{
            height: { sm: "16px", md: "24px", lg: "50px" },
            width: { sm: "16px", md: "24px", lg: "50px" },
            bgcolor: " #E0E0E0",
            borderRadius: "4px",
            "&.MuiIconButton-root:hover": {
              bgcolor: "#E0E0E0",
            },
            display: sliderItems.length <= 3 ? "none" : "flex",
          }}
          onClick={handlePrev}
        >
          <ArrowBackIosIcon
            sx={{ ml: "6px", fontSize: { sm: "12px", md: "14px", lg: "16px" } }}
          />
        </IconButton>
        <Box
          sx={{
            display: "flex",
            // justifyContent: sliderItems.length === 1 ? "center" : "center",
            justifyContent:"center",
            gap:"24px",
            width:
              sliderItems.length === 1
                ? "100%"
                : sliderItems.length <= 2
                ? "55%"
                : "100%",

            mx: "auto",
          }}
        >
          {slideImage.map((item, index) => {
            if (item.type === "IMAGE") {
              return (
                <Box
                  key={index}
                  sx={{
                    width: { sm: "93px", md: "129px" },
                    height: { sm: "72px", md: "133px" },
                    border:
                      "1px solid var(--shades-neutrals-grey-300, #E0E0E0)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box
                    component="img"
                    src={item.url}
                    alt={`Image ${index + 1}`}
                    sx={{
                      width: { sm: "70px", md: "100px" },
                      height: "100%",
                      objectFit: "contain",
                    }}
                    onClick={() => handleImageSelect(item, index)}
                  />
                </Box>
              );
            } else if (item.type === "lab360" || item.type === "vendor360") {
              return (
                <Box
                  key={index}
                  sx={{
                    width: { sm: "93px", md: "129px" },
                    height: { sm: "72px", md: "133px" },
                    border:
                      "1px solid var(--shades-neutrals-grey-300, #E0E0E0)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box
                 
                  
                   
                    sx={{ width: { sm: "40px", md: "100%" },
                    height:"100%",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center"
                    }}
                    onClick={() => handleImageSelect(item, index)}
                  >
                       <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.25"
                    y="0.25"
                    width="63.5"
                    height="63.5"
                    rx="3.75"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M30 17H26.1931C27.5535 15.0787 29.6064 14 32 14C36.4183 14 40 17.5817 40 22H42C42 16.4772 37.5228 12 32 12C29.1958 12 26.7251 13.1825 25 15.2703V12H23V19H30V17ZM34 27H37.8069C36.4465 28.9213 34.3936 30 32 30C27.5817 30 24 26.4183 24 22H22C22 27.5228 26.4772 32 32 32C34.8042 32 37.2749 30.8175 39 28.7297V32H41V25H34V27Z"
                    fill={`${activeIcon === "second" ? " #333333" : "#858585"}`}
                  />
                  <path
                    d="M20.644 49.126C19.9813 49.126 19.3467 49.0233 18.74 48.818C18.1333 48.6127 17.6247 48.3187 17.214 47.936L17.648 47.04C18.1053 47.4133 18.5767 47.684 19.062 47.852C19.5473 48.02 20.07 48.104 20.63 48.104C21.3673 48.104 21.9273 47.95 22.31 47.642C22.6927 47.3247 22.884 46.8627 22.884 46.256C22.884 45.6773 22.688 45.2387 22.296 44.94C21.904 44.632 21.33 44.478 20.574 44.478H19.09V43.512H20.476C21.1293 43.512 21.6473 43.344 22.03 43.008C22.4127 42.672 22.604 42.2147 22.604 41.636C22.604 41.1133 22.4267 40.7167 22.072 40.446C21.7267 40.166 21.2273 40.026 20.574 40.026C19.51 40.026 18.5907 40.404 17.816 41.16L17.382 40.25C17.7647 39.858 18.2453 39.5547 18.824 39.34C19.4027 39.116 20.0093 39.004 20.644 39.004C21.6147 39.004 22.3753 39.228 22.926 39.676C23.4767 40.124 23.752 40.7447 23.752 41.538C23.752 42.1447 23.5793 42.6673 23.234 43.106C22.8887 43.5353 22.422 43.8293 21.834 43.988V43.834C22.534 43.946 23.0753 44.226 23.458 44.674C23.8407 45.1127 24.032 45.668 24.032 46.34C24.032 47.1987 23.7287 47.88 23.122 48.384C22.5247 48.8787 21.6987 49.126 20.644 49.126ZM29.4165 49.126C28.2219 49.126 27.2979 48.706 26.6445 47.866C26.0005 47.0167 25.6785 45.8313 25.6785 44.31C25.6785 43.1713 25.8419 42.21 26.1685 41.426C26.4952 40.6327 26.9619 40.0307 27.5685 39.62C28.1752 39.2093 28.9079 39.004 29.7665 39.004C30.2799 39.004 30.7979 39.1113 31.3205 39.326C31.8432 39.5313 32.2725 39.8207 32.6085 40.194L32.1885 41.09C31.8339 40.726 31.4465 40.46 31.0265 40.292C30.6065 40.1147 30.1819 40.026 29.7525 40.026C28.8005 40.026 28.0679 40.3667 27.5545 41.048C27.0505 41.72 26.7985 42.7327 26.7985 44.086V45.388H26.6725C26.7379 44.856 26.8965 44.3987 27.1485 44.016C27.4099 43.624 27.7505 43.3253 28.1705 43.12C28.5905 42.9147 29.0572 42.812 29.5705 42.812C30.1679 42.812 30.6952 42.9427 31.1525 43.204C31.6099 43.4653 31.9692 43.834 32.2305 44.31C32.4919 44.7767 32.6225 45.3133 32.6225 45.92C32.6225 46.536 32.4872 47.0867 32.2165 47.572C31.9459 48.0573 31.5679 48.44 31.0825 48.72C30.5972 48.9907 30.0419 49.126 29.4165 49.126ZM29.3325 48.146C29.7619 48.146 30.1399 48.0573 30.4665 47.88C30.8025 47.6933 31.0592 47.4367 31.2365 47.11C31.4232 46.774 31.5165 46.3913 31.5165 45.962C31.5165 45.5327 31.4232 45.1547 31.2365 44.828C31.0592 44.5013 30.8025 44.2447 30.4665 44.058C30.1399 43.8713 29.7619 43.778 29.3325 43.778C28.9032 43.778 28.5252 43.8713 28.1985 44.058C27.8719 44.2447 27.6152 44.5013 27.4285 44.828C27.2512 45.1547 27.1625 45.5327 27.1625 45.962C27.1625 46.3913 27.2512 46.774 27.4285 47.11C27.6152 47.4367 27.8719 47.6933 28.1985 47.88C28.5252 48.0573 28.9032 48.146 29.3325 48.146ZM37.4891 49.126C36.3691 49.126 35.5104 48.692 34.9131 47.824C34.3157 46.956 34.0171 45.7007 34.0171 44.058C34.0171 42.406 34.3157 41.1507 34.9131 40.292C35.5104 39.4333 36.3691 39.004 37.4891 39.004C38.6184 39.004 39.4771 39.4333 40.0651 40.292C40.6624 41.1507 40.9611 42.4013 40.9611 44.044C40.9611 45.696 40.6624 46.956 40.0651 47.824C39.4677 48.692 38.6091 49.126 37.4891 49.126ZM37.4891 48.118C38.2731 48.118 38.8564 47.7867 39.2391 47.124C39.6217 46.4613 39.8131 45.4347 39.8131 44.044C39.8131 42.644 39.6217 41.622 39.2391 40.978C38.8564 40.3247 38.2731 39.998 37.4891 39.998C36.7144 39.998 36.1311 40.3247 35.7391 40.978C35.3564 41.6313 35.1651 42.6533 35.1651 44.044C35.1651 45.4347 35.3564 46.4613 35.7391 47.124C36.1311 47.7867 36.7144 48.118 37.4891 48.118ZM44.2876 43.148C43.8956 43.148 43.5409 43.0547 43.2236 42.868C42.9063 42.6813 42.6543 42.434 42.4676 42.126C42.2903 41.818 42.2016 41.468 42.2016 41.076C42.2016 40.684 42.2903 40.334 42.4676 40.026C42.6543 39.7087 42.9063 39.4613 43.2236 39.284C43.5409 39.0973 43.8956 39.004 44.2876 39.004C44.6796 39.004 45.0296 39.0973 45.3376 39.284C45.6456 39.4613 45.8883 39.704 46.0656 40.012C46.2523 40.32 46.3456 40.6747 46.3456 41.076C46.3456 41.468 46.2523 41.8227 46.0656 42.14C45.8883 42.448 45.6456 42.6953 45.3376 42.882C45.0296 43.0593 44.6796 43.148 44.2876 43.148ZM44.2876 42.378C44.6609 42.378 44.9596 42.2567 45.1836 42.014C45.4169 41.762 45.5336 41.4493 45.5336 41.076C45.5336 40.6933 45.4169 40.3807 45.1836 40.138C44.9596 39.8953 44.6609 39.774 44.2876 39.774C43.9236 39.774 43.6203 39.8953 43.3776 40.138C43.1443 40.3807 43.0276 40.6933 43.0276 41.076C43.0276 41.4493 43.1443 41.762 43.3776 42.014C43.6109 42.2567 43.9143 42.378 44.2876 42.378Z"
                    fill={`${activeIcon === "second" ? " #333333" : "#858585"}`}
                  />
                  <rect
                    x="0.25"
                    y="0.25"
                    width="63.5"
                    height="63.5"
                    rx="3.75"
                    // stroke="#E0E0E0"
                    // stroke-width="0.5"
                  />
                </svg>
                  </Box>
                </Box>
              );
            } else if (item.type === "VIDEO") {
              return (
                <Box
                  key={index}
                  sx={{
                    width: { sm: "93px", md: "129px" },
                    height: { sm: "72px", md: "133px" },
                    border:
                      "1px solid var(--shades-neutrals-grey-300, #E0E0E0)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BsFillPlayFill
                    size={90}
                    style={{ margin: "auto", color: "#A3A3A3" }}
                    onClick={() => handleImageSelect(item, index)}
                  />
                </Box>
              );
            } else {
              return null;
            }
          })}
        </Box>
        <IconButton
          sx={{
            height: { sm: "16px", md: "24px", lg: "50px" },
            width: { sm: "16px", md: "24px", lg: "50px" },
            bgcolor: " #E0E0E0",
            borderRadius: "4px",
            "&.MuiIconButton-root:hover": {
              bgcolor: "#E0E0E0",
            },
            display: sliderItems.length <= 3 ? "none" : "flex",
          }}
          onClick={handleNext}
        >
          <ArrowForwardIosIcon
            sx={{ fontSize: { sm: "12px", md: "14px", lg: "16px" } }}
          />
        </IconButton>
      </Box>
    </Box>
  );
};
